<template>
  <div id="report">
    <div class="full-overlay">
      <div class="overlay-header">
        <b-container fluid>
          <b-row align-h="center" align-v="center" class="my-md-4">
            <b-col>
            </b-col>
            <b-col cols="7">
              <div class="overlay-subnav text-center" v-if="$route.name != 'Results'" >
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) === 0" variant="link"  :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)-1]"><icon scale="2" name="angle-left"/></b-button>
                <span class="subnav-progress">
                  <router-link class="item" :key="index" v-for="(report, index) in $parent.availableReports" :class="{'active': report === $parent.openedReport}" :to="report"></router-link>
                </span>
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) >= $parent.availableReports.length -1" variant="link" :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)+1]"><icon scale="2" name="angle-right"/></b-button>
              </div>
            </b-col>
            <b-col class="text-right">
              <b-button class="icon--color" variant="link" to="/personal/results" id="close-button"><icon name="times" scale="2"/></b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="overlay-content">
        <!-- <img src="/img/illustrations/reports/theme_anxiety-gad-7.jpg" class="img-fluid"/> -->
        <b-container fluid class="px-0 pt-0 pb-4">
          <b-row align-v="center" align-h="center" class="py-4 mb-5 card--text">
            <b-col cols="12" sm="12" md="10" class="text-center p-3">
              <h1 class="info-headline">{{$t(`personal-results:title-${report}`)}}</h1>
              <h5><span>{{ $t(`personal-results:description-${report}`) }}</span></h5>
            </b-col>
          </b-row>
          <div v-if="personalAnxietyReport">
            <b-row align-v="center" align-h="center" class="mt-4">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col>
                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0(personalAnxietyReport.score)}}</span>
                      <span class="--scale">/ 21</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': true}" :style="{'background': `linear-gradient(90deg, rgba(87,203,60,1) 0%, rgba(215,193,14,1) ${$parent.formatPercent(0.5/(personalAnxietyReport.score/21))}, rgba(214,69,69,1) ${$parent.formatPercent(1/(personalAnxietyReport.score/21))})`, 'width': $parent.formatPercent(personalAnxietyReport.score / 21)}"></div>
                    </div>
                    <p class="tidbit">{{$t('common:updated')}} {{personalAnxietyReport.updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span>{{ $t(`personal-results:${report}-category-title-${personalAnxietyReport.category}`) }}</span>
                </h3>
              </b-col>
            </b-row>
            <b-row align-v="center" align-h="left" class="mt-4">
              <b-col cols="12" sm="12" md="10" lg="8" offset-md="1" offset-lg="1">
                <p style="white-space: pre-line; font-weight: bold;">
                  {{ $t(`personal-results:${report}-category-feedback-${personalAnxietyReport.category}`) }}
                </p>
                <p style="white-space: pre-line;">
                  {{ $t(`personal-results:${report}-general-feedback`) }}
                </p>
              </b-col>
            </b-row>
            <!--
            <b-row v-if="$parent.uwesanxietyChange !== null" align-v="center" align-h="center" class="my-5">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <div class="trend-indicator" :class="{'up': $parent.uwesanxietyChange >= 0.77, 'down': $parent.uwesanxietyChange <= -0.77, 'flat': Math.abs($parent.uwesanxietyChange) < 0.77 }">
                  <icon class="--icon" v-if="$parent.uwesanxietyChange > 0" name="caret-up"/>
                  <icon class="--icon" v-if="$parent.uwesanxietyChange < 0" name="caret-down"/>
                  <icon class="--icon" v-if="$parent.uwesanxietyChange == 0" name="minus"/>
                  <div class="--magnitude">
                    <span class="--value">{{Math.abs($parent.formatNumber0($parent.uwesanxietyChange))}}</span>
                  </div>
                </div>
                <div class="--reference-point">{{$t('personal-results:from')}} {{$parent.formatNumber0($parent.currentEngagementReport.previous.anxiety.score / 6 * 100)}} / 100 ({{$parent.currentEngagementReport.previous.anxiety.updatedAt | moment('MMMM YYYY')}})</div>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span v-if="$parent.currentanxietyDirectionClass !== null">{{ $t('personal-results:anxiety-direction-title-' + $parent.currentanxietyDirectionClass) }}</span><span v-if="$parent.uwesanxietyChange !== 0 && $parent.currentEngagementReport.categories === $parent.currentEngagementReport.previous.anxiety.class">{{ $t('personal-results:anxiety-class-same-' + $parent.currentEngagementReport.previous.anxiety.class) }}</span>
                  <span v-else-if="$parent.uwesanxietyChange > 0 && $parent.currentEngagementReport.categories !== $parent.currentEngagementReport.previous.anxiety.class">
                    {{ $t('personal-results:anxiety-class-level-up-' + $parent.currentEngagementReport.previous.anxiety.class + '--' + $parent.currentEngagementReport.categories) }}
                  </span>
                  <span v-else-if="$parent.uwesanxietyChange < 0 && $parent.currentEngagementReport.categories !== $parent.currentEngagementReport.previous.anxiety.class">
                    {{ $t('personal-results:anxiety-class-level-down-' + $parent.currentEngagementReport.previous.anxiety.class + '--' + $parent.currentEngagementReport.categories) }}
                  </span>
                </h3>

              </b-col>
            </b-row>
            <b-row align-v="center" align-h="center" class="mt-2" v-if="$parent.hasDataForanxietyComparison">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col cols="12">

                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0($parent.currentCompanyEngagementReport.stats)}}</span>
                      <span class="--scale">/ 100</span>
                    </div>

                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': $parent.companyanxietyPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentCompanyEngagementReport.categories), 'width': $parent.companyanxietyPercent}"></div>
                    </div>
                    <p class="tidbit">{{$t('personal-results:current-average-of-team', {account: $store.state.account.name})}}, {{$t('common:updated')}} {{$parent.currentCompanyEngagementReport.updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title" v-if="$parent.getanxietyDifferenceDegree() === 0">{{$t('personal-results:team-anxiety-comparison-0')}}</h3>
                <h3 class="feedback-title" v-if="$parent.getanxietyDifferenceDegree() > 0 && $parent.getPersonalTeamanxietyDifference() < 0">{{$t('personal-results:team-anxiety-comparison-below-' + $parent.getanxietyDifferenceDegree())}}</h3>
                <h3 class="feedback-title" v-if="$parent.getanxietyDifferenceDegree() > 0 && $parent.getPersonalTeamanxietyDifference() > 0">{{$t('personal-results:team-anxiety-comparison-above-' + $parent.getanxietyDifferenceDegree())}}</h3>
              </b-col>
            </b-row> -->

          </div>
          <div v-else class="text-center">
            {{ $t('personal-results:results-not-available') }}
          </div>
        </b-container>
      </div>
      <div class="overlay-footer d-none d-md-block">
        <b-container fluid>
          <b-row align-h="center">
            <b-col class="text-center mt-3 mb-3 my-md-4">
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      report: 'anxiety-gad-7'
    }
  },
  async mounted () {
    this.$parent.openedReport = 'anxiety'
    this.loadReport()
  },
  methods: {
    loadReport: function () {
      if (!this.personalAnxietyReport) {
        this.$store.dispatch('loadPersonalAnxietyReport')
      }
    }
  },
  computed: {
    ...mapGetters(['personalAnxietyReport'])
  }
}
</script>

<style lang="scss" scoped>
</style>
